"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllMeterPins = getAllMeterPins;
exports.getAllMeters = getAllMeters;
exports.getChannelHeaderIfAnonym = void 0;
exports.getMeterPinDetails = getMeterPinDetails;
exports.getMeterReadDate = getMeterReadDate;
exports.getMeterReadingData = getMeterReadingData;
exports.saveMeterReadingData = saveMeterReadingData;
exports.sendEmailData = sendEmailData;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _config = _interopRequireDefault(require("../config/config"));
var _SessionHandler = _interopRequireWildcard(require("../utils/SessionHandler"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var getChannelHeaderIfAnonym = exports.getChannelHeaderIfAnonym = function getChannelHeaderIfAnonym() {
  return _SessionHandler.default.getLoginType() === _SessionHandler.loginTypes.loggedIn ? {} : {
    headers: {
      'X-Client': _config.default.CHANNEL_CONFIG.anonymMR
    }
  };
};
function getMeterReadingData() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/meters?filterBy=openReadingOrders&withInfoMessage=true"), {}, getChannelHeaderIfAnonym());
}
function saveMeterReadingData(meterData) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/readingresults"), meterData, getChannelHeaderIfAnonym());
}
function sendEmailData(emailData) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/readingresultconfirmation"), emailData, getChannelHeaderIfAnonym());
}
function getAllMeters() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/meters"));
}
function getMeterReadDate(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/futurereadings/").concat(contractAccountId)); // needs to add root source
}
function getAllMeterPins() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/meterpins"));
}
function getMeterPinDetails(serialNumber) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/meterpins/").concat(serialNumber));
}